import script from "./AgentEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentEditView.vue?vue&type=script&setup=true&lang=js"

import "./AgentEditView.vue?vue&type=style&index=0&id=e5b8b4ec&lang=css"
import "./AgentEditView.vue?vue&type=style&index=1&id=e5b8b4ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5b8b4ec"]])

export default __exports__